// Channels
export const PUSHER_CHANNEL_SR_QUEUE = 'sr-queue-';
export const PUSHER_CHANNEL_PRIVATE_SR_QUEUE = 'private-sr-queue-';

// Events
export const PUSHER_EVENT_UPDATE_QUEUE = 'update-queue';
export const PUSHER_EVENT_CLIENT_UPDATE_QUEUE = 'client-update-queue';